import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-register-per-page',
  templateUrl: './register-per-page.component.html',
  styleUrls: ['./register-per-page.component.scss'],
})
export class RegisterPerPageComponent implements OnInit, OnChanges {
  @Output()
  public changeQuantity: EventEmitter<number>;

  @Input()
  public set quantity(quantity: number) {
    this.totalRegister = quantity;
  }

  @Input()
  public set quantityPerPage(quantityPerPage: number) {
    if (quantityPerPage) {
      this.customQuantity = quantityPerPage;
    }
  }

  public totalRegister: number;
  public defaultNumber: number;
  public pageQuantities: number[];
  public customQuantity: number;

  constructor() {
    this.changeQuantity = new EventEmitter();
    this.totalRegister = 0;
    this.pageQuantities = [10, 20, 30, 50, 100];
    this.customQuantity = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quantity && changes.quantity.currentValue) {
      this.changeQuantityPerPage(changes.quantity.currentValue);
    }
  }

  /**
   * Init component
   */
  public ngOnInit(): void {
    const customQuantity = { target: { value: this.customQuantity } };
    this.changeQuantityPerPage(this.customQuantity ? customQuantity : null);
  }

  /**
   * Function to change the register quantity per page
   *
   * @param $event Event triggered from select
   */
  public changeQuantityPerPage($event?: any): void {
    if ($event && $event.target) {
      this.changeQuantity.emit($event.target.value);
    } else {
      this.changeQuantity.emit(this.pageQuantities[0]);
    }
  }
}
